var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.c))]),_c('v-btn',{on:{"click":_vm.run}},[_vm._v(" RUN ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }